import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia,  Divider, Container } from '@material-ui/core/';
import {useStyles} from './style';

import ModalImage from 'components/ImageModal';
import Alert from '@material-ui/lab/Alert';

function DatosDeIdentidad({datosIdentidadFoto, datosIdentidad}) {
    // console.log('DatosDeIdentidad', datosIdentidadFoto, datosIdentidad)
    const classes = useStyles(),
    [verImagen, setVerImagen] = useState(false),
    [datosImagen, setDatosImagen] = useState({image:'', title:'',});

    const VerImagen =(datosImagen)=>{
        setDatosImagen({image: datosImagen.foto, title: datosImagen.tipo})
        setVerImagen(true)
    }
    const CerrarVerImagen =()=>{
        setVerImagen(false)
    }

return (
    <div>
        { datosIdentidadFoto.fotosVieneVacio ?
            <Container maxWidth="sm">
                <Alert variant="outlined" severity="error">
                    {datosIdentidadFoto.mensajeFotosVieneVacio}
                </Alert>
            </Container>                         
            : (
                <Grid container className={classes.rootGrid} justify="center" >
                    <Grid item xs={12}>
                        <div className={classes.centerTitle}><Divider /> <strong>DATOS DE IDENTIDAD</strong> <Divider /></div>
                    </Grid >
                    {datosIdentidad.map((value, index) => (
                        <Grid key={index} item>
                            <Card className={classes.rootCard}>
                                <CardActionArea >
                                    <div className={classes.contentMedia}>
                                        <CardMedia
                                            alt="image"
                                            image={value.foto}
                                            title="image"
                                            className={classes.media}
                                            onClick={()=>VerImagen(value)}
                                        />
                                    </div>
                                    <CardContent  className={classes.cardContent}>
                                        <Grid item xs={12}>
                                            <div className={classes.centerTitlePhoto}><strong>{value.tipo}</strong> </div>
                                        </Grid >
                                    </CardContent>
                                </CardActionArea>
                            </Card>                                    
                        </Grid>
                    ))}
                    <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen}/>
                </Grid>  
            )}    
    </div>      
  );
}
export default DatosDeIdentidad;